import { connect } from 'react-redux';
import CrearRecepcionesClass from './CrearRecepcionesClass';

const mstp = state => {
    const me = state.login.me;
    return {
        me
    }
};

export default connect(mstp)(CrearRecepcionesClass)
